import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { apiRoutes } from './api-routes';

export interface MenuItemsResponse {
  item_types: ItemType[];
}

export interface ItemType {
  _id: number;
  name: string;
  items: Item[];
}

export interface Item {
  _id: number;
  name: string;
  price: number;
  description: string;
  quantity: number;
  customizations: any;
  discounted_price: number;
  status: string;
  image_thumb_url: string;
  discount_config?: DiscountConfig;
}

export interface DiscountConfig {
  type: string;
  value: number;
  max_discount_value: number;
  max_apply_per_item: number;
}

export const getMenuWSFn = async (
  store_id: number,
  config: AxiosRequestConfig = {}
): Promise<MenuItemsResponse> => {
  const response = await publicHttpClient.get<MenuItemsResponse>(
    apiRoutes.ahafood.store.get_menu_items(store_id),
    {
      ...config,
    }
  );

  return response?.data;
};

export const useGetMenuWS = (
  store_id: number,
  opts?: Omit<UseQueryOptions<MenuItemsResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<MenuItemsResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.get_menu_items(store_id)],
    queryFn: () => getMenuWSFn(store_id),
    ...opts,
  });
};
